import { PurchasedPlansComponent } from './../../purchased-plans/purchased-plans.component';

import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ITableColumnHeader } from 'src/app/models/table-column-header';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { NavigationService } from '../../../providers/navigation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DeactivateBusinessComponent } from '../deactivate-business/deactivate-business.component';
import { SharedService } from '../../../providers/shared.service';
import { EmployeeSubscriptionComponent } from '../../../shared/components/employee-subscription/employee-subscription.component';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { AddNewEmployeeComponent } from 'src/app/shared/components/add-new-employee/add-new-employee.component';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { EmployeeChatComponent } from 'src/app/shared/components/employee-chat/employee-chat.component';
import { YoutubeEmbedVideoComponent } from '../../new-v2-pages/new-v2-component/youtube-embed-video/youtube-embed-video.component';

@Component({
  selector: 'sm-employees',
  templateUrl: './employees.component.html',
  styleUrls: ['./employees.component.scss']
})
export class EmployeesComponent implements OnInit, OnDestroy {
  hidediv: boolean = false
      panelState: any = [true, false, false, false, false];
  messageList: any[] = [];
  employeeData: any = []
  entityHashId: string =''
  public loader: boolean = false;
  senderHashId:any = localStorage.getItem(SM_CONSTANTS.PROFILE_HASH)
  receiverHashId:any
  previousChatHash:any
  foundEmployee:any = {
    name: '',
    img: '',
    employeeHash: ''
  }
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "name",
      columnProperty: "name"
    },
    {
      columnName: "date of joining",
      columnProperty: "dateOfJoin"
    },
    {
      columnName: "phone",
      columnProperty: "phone"
    },
   
    {
      columnName: "total sales",
      columnProperty: "totalSales"
    },
  ];
  private _apiSubscription: Subscription;
  clickEventSubscription: Subscription;
  constructor(private sharedService: SharedService, private _apiService: ApiService,private _dialog: MatDialog, private _navService: NavigationService, private router: Router, private route: ActivatedRoute, private loaderservice: LoaderServiceService,private angularFireMessaging: AngularFireMessaging) { 
    this._navService.hideSidebarAndNav = false;
    this.clickEventSubscription = this.sharedService.getClickEvent().subscribe(() => {
      this.ngOnInit();
    })
    
    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.GET_EMPLOYEE_LIST_RESULT){
        console.log(resData);
        this.employeeData = []
        if(resData.result){
          resData.result.forEach((element:any) => {
            if(this.selectedValue == 1){
              if(element.isExEmployee == 0){
                if(element.is_owner == 0){
                  if(element.addressInfo && element.addressInfo!= null && element.addressInfo!= 'null'){
                    element.addressInfo = (JSON.parse(element.addressInfo)).addressLine
                      }
                    if(element.assigned_slots){
              element.assigned_slots = typeof element.assigned_slots == 'string' ? JSON.parse(element.assigned_slots) : element.assigned_slots
              element.formatted_assigned_slots = this.getUniqueTimeRangesWithCount(element.assigned_slots)
            }
                  this.employeeData.push(element)
                }
              }
            }
            else if(this.selectedValue == 2){
              if(element.isExEmployee == 1){
                if(element.is_owner == 0){
                  if(element.addressInfo && element.addressInfo!= null && element.addressInfo!= 'null'){
                    element.addressInfo = (JSON.parse(element.addressInfo)).addressLine
                      }
  
                  this.employeeData.push(element)
                }
              }
            }
          });
        }
            this.loaderservice.showLoader = false
            this.loader = false;
            this.hidediv = false
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_SEND_EMPLOYEE_REQUEST){ 
        if(resData.result){
          // this.ngOnInit()
          
          // window.location.reload()
          this.router.navigate(["/businesses", "details", "employees", "employee-invitation"], {
            queryParamsHandling: 'preserve'
          });
        }
       }
       if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_EMPLOYEE_REQUEST_LIST){
        console.log(resData);
        this.employeeData = []
        if(resData.result){
          resData.result.forEach((element:any) => {
            this.employeeData.push(element)
          });
        }
        this.loader = false
        this.loaderservice.showLoader = false
        this.hidediv = false
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_MESSAGES_BY_ID_FOR_EMPLOYEE){
        // this.chatThreads = []
        if(resData.result){

          resData.result.forEach((element:any) => {
            if(element.senderInfo && element.receiverInfo){
              if(element.senderInfo && typeof element.senderInfo == 'string'){
                element.senderInfo = JSON.parse(element.senderInfo)
              }
              if(element.receiverInfo && typeof element.receiverInfo == 'string'){
                element.receiverInfo = JSON.parse(element.receiverInfo)
              }
              console.log(this.senderHashId);
              console.log(this.receiverHashId);
              
             if( (element.senderInfo.hash_id == this.senderHashId && element.receiverInfo.hash_id == this.receiverHashId && element.entity_public_hash_id == localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID)) || (element.senderInfo.hash_id== this.receiverHashId && element.receiverInfo.hash_id == this.senderHashId && element.entity_public_hash_id == localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID))){
              this.previousChatHash = element.hash_id
             }

            }
          });
          console.log(this.previousChatHash);
          
        }
        this.loaderservice.showLoader = false
        this._dialog.open(EmployeeChatComponent, {
          width: "500px",
          panelClass: 'custom-dialog-container',
          data: {
            title: this.foundEmployee.name,
            ref: this._dialog,
            previousChatHash: this.previousChatHash,
            employeeImage: this.foundEmployee.img,
            employeeHash: this.receiverHashId
          },
        });
      }
    
    });
    // this.loader = false;
  }

  ngOnInit(): void {
    this.loader =true
    this.route.queryParams.subscribe(data => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash

      
    })
    this.loaderservice.showLoader = true
    if(sessionStorage.getItem('toShowInvitation') && sessionStorage.getItem('toShowInvitation') == '1'){
      sessionStorage.removeItem('toShowInvitation')
      this.selectedValue = 3
      this._apiService.getEmployeeRequestList(this.entityHashId);
    }else{
      
      this._apiService.getEmployeeList(this.entityHashId);
      
    }

    
  }

  createNotification(title:any, text:any) {
    const noti = new Notification(title, {
      body: text,
    });
  }
  

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }

  // test(row:any){
  //   console.log(row);
    
  // }

  opencontact(){
    this.router.navigate(['/contact-us']);
  }

  openvideo(){
    this._dialog.open(YoutubeEmbedVideoComponent,{
    width:'1000px',
    disableClose:true,
    data:{
      link:"https://www.youtube.com/embed/_gn1Jq1OeGM?si=OLs3C2p0ZESpz-uq",
      title: 'Adding Employees & Co-Workers in LookzUp Business Platform.'
    }})
    }

  viewSubscription(rowvalue:any){
    console.log(rowvalue);
    this._dialog.open(EmployeeSubscriptionComponent, {
      data: JSON.parse(rowvalue),
      maxWidth: 500,
      panelClass: 'employee-subscription-dialog'
    });
  }

  addNewEmployee(){
    this._dialog.open(AddNewEmployeeComponent, {
      width: '500px',
      data: {
        title: 'Add New Employee',
        ref: this._dialog
      },
    });
  }
  selectedValue:any = 1 
  selectChip(value:any){
    this.selectedValue = value
    if(value == 1 || value == 2){
      this.employeeData = []
      this.loaderservice.showLoader = true
      this.hidediv = true
      this._apiService.getEmployeeList(this.entityHashId)
    }
    else{
      this.employeeData = []
      this.hidediv = true
      this.loaderservice.showLoader = true
      this._apiService.getEmployeeRequestList(this.entityHashId);
    }
  }

  viewDetails(employeeHash:any){
    this.router.navigate(["/businesses", "details", "employees", "employee-details"], {
      queryParams: {'employeeHash': employeeHash},
      queryParamsHandling: 'merge'
    });
  }
  viewInvitationDetails(employeeHash:any){
    this.router.navigate(["/businesses", "details", "employees", "invitation-details"], {
      queryParams: {'requestHashId': employeeHash},
      queryParamsHandling: 'merge'
    });
  }

  openPreviousEmployees(){
    this.router.navigate(["/businesses", "details", "employees", "previous-employees"], {
      queryParamsHandling: 'preserve'
    });
  }
  openEmployeeInvitation(){
    this.router.navigate(["/businesses", "details", "employees", "employee-invitation"], {
      queryParamsHandling: 'preserve'
    });
  }
 
  newemployeedetails(){
    this.router.navigate(['employee-details'])

  }

  employeeplan(){
    sessionStorage.setItem(SM_CONSTANTS.CURRENT_ROUTE_FOR_NEW_EMPLOYEE, '2')
    this.router.navigate(['purchased-plan'],{relativeTo: this.route, queryParamsHandling:'preserve'})
  }
  openMessages(item:any,event:Event){
    event.stopPropagation()
    this.loaderservice.showLoader = true
    this.receiverHashId = item.profileHashId
    this.foundEmployee.name = item.name
    this.foundEmployee.img = item.imgThumbUrl
    this.foundEmployee.employeeHash = item.employeeHashId
    this._apiService.getMessagesByIDForEmployee()
    
  }
  openLink(url: string): void {
    window.open(url, '_blank');
  }

  getUniqueTimeRangesWithCount(timeRanges: any[]): any[] {
  const map = new Map<string, any>();

  for (const range of timeRanges) {
    const key = `${range.start_time}|${range.end_time}`;
    if (map.has(key)) {
      map.get(key).count += 1;
    } else {
      map.set(key, {
        start_time: range.start_time,
        end_time: range.end_time,
        count: 1
      });
    }
  }

  return Array.from(map.values());
}
}
